import { throttle } from 'lodash'
import { sha256 } from "js-sha256"
import { JSEncrypt } from 'jsencrypt'
import axios from 'axios'
import qs from 'qs'
import Config from '../config'
import store from '../store'
import { Toast } from 'vant'
// import isWebview from "js-is-webview"

const Utils = {}

Utils.getAppToken = () => {
  const url = window.location.href.split('#')[1]
  let params = {}
  if (url.indexOf('access_token') == -1) {
    if (Utils.getOpenType() === 'app') {
      Toast({ message: '没有获取到access_token', className: 'toast-trans' })
    }
    return
  } else {
    const params_str = url.split('?')[1]
    const params_arr = params_str.split('&')
    params_arr.forEach(item => {
      params[item.split('=')[0]] = item.split('=')[1]
    })
    localStorage.setItem('access_token', params.access_token)
  }
}

/**
 * @desc 微信静默授权，获取code，调用js-sdk时使用
 */
const wechatAuthorize = () => {
  const redirect_uri = encodeURIComponent(location.href.split('#')[0])
  const appid = Config.wechatAppid
  const scope = 'snsapi_base'
  const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=${scope}&state=STATE#wechat_redirec`
  location.href = url
}

/**
 * @desc 授权后，跳转回的路径携带code参数，把code存在缓存里
 */
Utils.getWechatCode = () => {
  if (localStorage.getItem('wechat_token')) return
  const url = window.location.href.split('#')[0]
  let params = {}
  if (url.indexOf('code') == -1) {
    wechatAuthorize()
  } else {
    const params_str = url.split('?')[1]
    const params_arr = params_str.split('&')
    params_arr.forEach(item => {
      params[item.split('=')[0]] = item.split('=')[1]
    })
    setWechatToken(params.code)
  }
}

Utils.getCodeAndLogin = async () => {
  if (localStorage.getItem('access_token')) return
  const url = window.location.href.split('#')[0] || ""
  let params = {}
  if (url.indexOf('code') == -1) {
    return
  } else {
    const params_str = url.split('?')[1]
    const params_arr = params_str.split('&')
    params_arr.forEach(item => {
      params[item.split('=')[0]] = item.split('=')[1]
    })
    if (params.state == 'login') {
      const post_params = {
        code: params.code
      }
      const Authorization = Utils.getCostudyAuthorizations('/v1/wechat/login', post_params)
      const config = {
        headers: {
          "Costudy-Authorization": Authorization
        }
      }
      const res = await axios.post(`${Config.coApi}v1/wechat/login`, qs.stringify(post_params), config)
      if (res.data.errCode == 76) {
        Toast({ message: '登录失败，验证超时', className: 'toast-trans' })
      }
      if (res.data.data) {
        if (res.data.data.user.avatar && !res.data.data.user.avatar.startsWith('http')) {
          res.data.data.user.avatar = `https://image.co-study.com.cn/app/image/avatar/${res.data.data.user.avatar}`
        }
        Toast({ message: '登录成功', className: 'toast-trans' })
        store.commit('setUserinfo', res.data.data.user)
        localStorage.setItem('access_token', res.data.data.access_token)
      }
    }
  }
}

const setWechatToken = async (code) => {
  const params = {
    code
  }
  const Authorization = Utils.getCostudyAuthorizations('/v1/wechat/gettoken', params)
  const config = {
    headers: {
      "Costudy-Authorization": Authorization
    }
  }
  const res = await axios.post(`${Config.coApi}v1/wechat/gettoken`, qs.stringify(params), config)
  if (res.data.data.token) {
    localStorage.setItem('wechat_token', res.data.data.token)
  } else {
    Utils.getWechatCode()
  }
}

/**
 * @desc 授权后，跳转回的路径携带code参数，把code存在缓存里
 */
Utils.getQqCodeLogin = async () => {
  if (localStorage.getItem('access_token')) return
  let params = {}
  if (window.location.href.indexOf('code') == -1) {
    return
  } else {
    const params_str = window.location.href.split('#')[1].split('?')[1]
    const params_arr = params_str.split('&')
    params_arr.forEach(item => {
      params[item.split('=')[0]] = item.split('=')[1]
    })

    const post_params = {
      code: params.code,
      uri: `${Config.baseURL}#/index`
    }
    const Authorization = Utils.getCostudyAuthorizations('/v2/qq/login', post_params)
    const config = {
      headers: {
        "Costudy-Authorization": Authorization
      }
    }
    const res = await axios.post(`${Config.coApi}v2/qq/login`, qs.stringify(post_params), config)
    if (res.data.errCode == 76) {
      Toast({ message: '登录失败，验证超时', className: 'toast-trans' })
    }
    if (res.data.data) {
      if (res.data.data.user.avatar && !res.data.data.user.avatar.startsWith('http')) {
        res.data.data.user.avatar = `https://image.co-study.com.cn/app/image/avatar/${res.data.data.user.avatar}`
      }
      Toast({ message: '登录成功', className: 'toast-trans' })
      store.commit('setUserinfo', res.data.data.user)
      localStorage.setItem('access_token', res.data.data.access_token)
    }
    // const redirect_uri = encodeURIComponent(`${Config.baseURL}#/index`)
    // const appid = Config.qqAppid
    // const appKey = '436d45bc6052c9d09528a3100a0dbd59'
    // const url = `https://graph.qq.com/oauth2.0/token?grant_type=authorization_code&client_id=${appid}&client_secret=${appKey}&redirect_uri=${redirect_uri}&code=${code}`
    // alert(url)
    // location.href = url
  }
}

/**
 * @desc 获取打开方式，微信、qq、浏览器、app？
 */
Utils.getOpenType = () => {
  const userAgent = navigator.userAgent
  // const _isWebview = new isWebview()
  let openType
  if (userAgent.match(/CoStudy/i) == "CoStudy") {
    openType = 'app'
  } else if (userAgent.match(/MicroMessenger/i) == "MicroMessenger") {
    openType = 'wechat'
  } else if (userAgent.match(/QQTheme/i) == "QQTheme") {
    openType = 'qq'
  } else {
    openType = 'browser'
  }
  return openType
}

/**
 * @desc 节流
 */
Utils.throttle = (func, wait = 50) => throttle(func, wait)

const privateKeyString = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCCn67gL8epZspKv8Id/rCWJ62k
olKV7HqoYiGn7PZdaa1pojNsiTeJOsvUh1fC3BJWv72mU1HSBRaY9Kt22ZRpIZiB
wZc9AOd7s2H0IcAAi8joLcBz75i/rd2fGSjgdIox4svGRbEA8uuqiISdcqXd4gS2
SCZO8+jh/UpOSkMNbwIDAQAB
-----END PUBLIC KEY-----`

/**
 * @param {*} inputString 
 */
const sha256withRSA = (inputString) => {
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey(privateKeyString)
  const originSign = encrypt.encrypt(inputString)
  return originSign
}

/**
 * @desc 获取n位随机字符窜
 * @param {Number} n
 */
Utils.getRandomStr = (n) => {
  let str = ""
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890";
  for (let i = 0; i < n; i++) {
    str += chars.charAt(Math.floor(Math.random() * 62));
  }
  return str
}

/**
 * 获取Costudy_Authorizations
 * @param {*} params 
 */
Utils.getCostudyAuthorizations = (url, params) => {
  const timestamp = new Date().getTime().toString().substring(0, 10)
  const nonce_str = Utils.getRandomStr(20)
  const signature = sha256withRSA(sha256(`POST\n${url}\n${timestamp}\n${nonce_str}\n${JSON.stringify(params)}\n`))
  return JSON.stringify({
    timestamp,
    signature,
    nonce_str,
    serial_no: "costudy"
  })
}

Utils.isIosOrAndroid = function () {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  let isStr = ''
  if (isAndroid) {
    isStr = 'android'
  }
  if (isiOS) {
    isStr = 'ios'
  }
  return isStr
}

export default Utils
